import { plainToInstance } from 'class-transformer';
import { useNewXbmGetLoggedInUserDataQuery } from './gql/getUserData.generated';
import { Customer } from '@domain/Customer';
import { UserService } from './user.ports';
import { useNumberOfBriefingsStore } from '@infrastructure/store';

class UserAdapter implements UserService {
  getCurrentUser() {
    const [, setNumberOfBriefings] = useNumberOfBriefingsStore();

    const { loading, error, data } = useNewXbmGetLoggedInUserDataQuery({
      fetchPolicy: 'cache-first',
      onCompleted(data) {
        setNumberOfBriefings(
          data?.erecruitingSourcingServiceBriefingList?.total ?? 0,
        );
      },
    });

    return {
      loading,
      error,
      currentUser: plainToInstance(Customer, data?.viewer),
    };
  }
}

const userAdapter = new UserAdapter();

export { userAdapter };
